export const ENTITY_ASSETS = {
  sheepBlue: '/assets/entities/sheep_blue.png',
  sheepGreen: '/assets/entities/sheep_green.png',
  sheepPurple: '/assets/entities/sheep_purple.png',
  sheepYellow: '/assets/entities/sheep_yellow.png',
  dachshund: '/assets/entities/dachshund.png',
  goldenDachshund: '/assets/entities/dachshund_gold.png',
  shepherdDog: '/assets/entities/shepherd.png',
};

export const SHOP_TOOLTIP_BY_KEY: Record<string, string> = {
  sheep:
    'Sheep produce wool during income. You win by having the most sheep when the board can no longer accept placements.',
  dachshund: 'Dachshund protects adjacent sheep, but is removed if Wolf Pack appears.',
  goldenDachshund:
    'Golden Dachshund protects adjacent sheep and grants gold for each adjacent sheep during income.',
  shepherdDog: 'Shepherd Dog protects adjacent sheep and survives Wolf Pack.',
  lambCard:
    'Lamb Cards are drawn face down. You can activate one card per turn during sell or buy.',
};
